import React, { useMemo } from 'react'
import PropTypes from 'prop-types'
import { Box, Select, MenuItem } from '@mui/material'
import { eachDayOfInterval, format, isSameDay } from 'date-fns'
import { useSelector } from 'react-redux'
import { fr } from 'date-fns/locale'
import { ACTIVITY_COLLECTION, REQUEST_COLLECTION, USER_COLLECTION } from '../../_constants/globals'
import { useFirestore } from '../../hooks/useFirestore'


const HorizPlanning = ({ userId, activityId }) => {
  
  const selectedActivityId = useSelector(state => state.data.selectedActivityId)
  const requestHooks = useFirestore(REQUEST_COLLECTION)
  const dbRequests = requestHooks.getDocs()
  const activityHooks = useFirestore(ACTIVITY_COLLECTION)
  const dbActivities = activityHooks.getDocs()
  const userHooks = useFirestore(USER_COLLECTION)
  
  const { aircrafts, firstDayDate, lastDayDate } = useMemo(() => dbActivities?.find(a => a.id === selectedActivityId), [dbActivities, selectedActivityId])
  const requests = useMemo(() => dbRequests.filter(r => r.userRef.id === userId), [dbRequests, userId])
  const days = useMemo(
    () => firstDayDate && lastDayDate && eachDayOfInterval({ start: firstDayDate, end: lastDayDate }),
    [firstDayDate, lastDayDate],
  )
  
  const handleSetRequest = (aircraft, day, period, flightType) => requestHooks.setDoc(
    requests.find(r => r.aircraft === aircraft.name && isSameDay(r.day, day) && r.period === period)?.id || null,
    {
      activityRef: activityHooks.getDocRef(activityId),
      userRef: userHooks.getDocRef(userId),
      flightType,
      aircraft,
      day,
      period,
    },
  )
  
  return (
    <Box component='table' sx={{
      borderCollapse: 'collapse',
      '& td': { borderLeft: '1px solid black' },
      width: '100%',
    }}>
      <thead>
        <tr>
          <th colSpan={2} />
          {days.map(day => <th key={day.getTime() + 'head'}>{format(day, 'EEEE', { locale: fr })}</th>)}
        </tr>
      </thead>
      <tbody>
        {aircrafts.reduce((acc, val) => [...acc, { aircraft: val, period: 'AM' }, { aircraft: val, period: 'PM' }], []).map(({ aircraft, period }) =>
          <Box component='tr' key={aircraft.name + period} sx={{ borderTop: '1px solid black' }}>
            {period ==='AM' && <th rowSpan={2}>{aircraft.name}</th>}
            <th>{period}</th>
            {days.map(day => <td key={day.getTime() + period}>
              <Select
                variant='standard'
                fullWidth
                value={requests.find(r => r.aircraft === aircraft.name && isSameDay(r.day, day) && r.period === period)?.flightType || ''}
                onChange={e => handleSetRequest(aircraft.name, day, period, e.target.value)}
                sx={{ '&:before': { borderBottom: 'none' } }}
              >
                <MenuItem value=''><em>vide</em></MenuItem>
                <MenuItem value='Solo'>Solo</MenuItem>
                <MenuItem value='Double'>Double</MenuItem>
                <MenuItem value='Passager'>Passager</MenuItem>
              </Select>
            </td>)}
          </Box>,
        )}
      </tbody>
    </Box>
  )
}

HorizPlanning.propTypes = {
  userId: PropTypes.string.isRequired,
  activityId: PropTypes.string.isRequired,
}

export default HorizPlanning
